export interface RegionToDelete {
  id: number;
  titleEn: string;
  titleAr: string;
}

export type DeleteDialogState = 'closed' | 'confirm' | 'in-use';

export interface ApiErrorResponse {
  code?: string;
  messageEn?: string;
  messageAr?: string;
  reqBodyErrors?: string[];
}

export const DELETE_REGION_ERROR_CODES = {
  REGION_IN_USE_PHARMACY: 'REGION_IN_USE_PHARMACY',
  REGION_IN_USE_ROUTE: 'REGION_IN_USE_ROUTE',
  REGION_IN_USE: 'REGION_IN_USE',
} as const;
